import { useContext, useEffect } from 'react'
import { ApplicationContext } from '../context/application'
import { useGetApplicationAnswersLazyQuery } from '../../types/graphql'
import { useRouter } from 'next/router'

export const useApplicationAnswers = function useApplicationAnswers() {
    const applicationContext = useContext(ApplicationContext)
    const router = useRouter()
    const [getApplicationAnswers, { data, loading, error, refetch, called }] = useGetApplicationAnswersLazyQuery()

    useEffect(() => {
        const applicationId = router.query.applicationId?.toString()
        if (applicationId) {
            void getApplicationAnswers({ variables: { applicationId: applicationId } })
        }
    }, [router])

    useEffect(() => {
        if (data) {
            applicationContext.setAnswers(data.allUserAnswers)
        }
    }, [data])

    const getAnswersByCategory = (category: string) => {
        return applicationContext.answers.filter((answer: { category: string }) => {
            return answer.category === category
        })
    }

    return {
        getAnswersByCategory,
        loading,
        error,
        refetch,
        called,
    }
}
